<template>
  <div class="form-group smaller">
    <label class="access-form__label">Modifications effectuées sur les réglages</label>
    <div class="form-row mb-2 mb-sm-1 mb-md-2 mb-lg-1" v-for="(row, i) in settings" :key="'row' + i">
      <div class="col-12 col-sm-4 col-md-12 col-lg-4 mb-1 pr-0" v-for="(setting, j) in row" :key="'cell' + j">
        <div class="form-row">
          <label class="access-form__label col-auto col-form-label pr-0">PR</label>
          <div class="col-4">
            <input type="text" v-model="setting.key" size="4" class="form-control smaller px-1 rounded" @input="setSetting">
          </div>
          <label class="access-form__label col-auto col-form-label px-0">:</label>
          <div class="col-5 pr-0">
            <input type="text" v-model="setting.value" size="10" class="form-control smaller px-1 rounded setting-value" :disabled="!setting.key" @input="setSetting">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportSettings',
  props: {
    settingsSummary: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      settings: [
        [
          { key: null, value: null },
          { key: null, value: null },
          { key: null, value: null }
        ],
        [
          { key: null, value: null },
          { key: null, value: null },
          { key: null, value: null }
        ],
        [
          { key: null, value: null },
          { key: null, value: null },
          { key: null, value: null }
        ]
      ]
    }
  },
  created () {
    if (this.$route.params.reportId !== 'new') this.setExistingSettings()
  },
  methods: {
    setExistingSettings: _.debounce(function () {
      for (const [key, value] of Object.entries(this.settingsSummary)) {
        let emptyPair = _.flatten(this.settings).find(pair => _.isEmpty(pair['key']) && _.isEmpty(pair['value']))
        if (emptyPair) {
          emptyPair['key'] = key
          emptyPair['value'] = value
        }
      }
    }, 500),
    setSetting () {
      let settings = {}
      _.flatten(this.settings).forEach(pair => {
        if (!pair['key'] && pair['value']) {
          pair['value'] = null
        }
        if (pair['key'] && pair['value']) {
          settings[pair['key']] = pair['value']
        }
      })
      this.$emit('settings', settings)
    }
  }
}
</script>

<style>
.setting-value[disabled] {
  background-color: #fafafa;
}
</style>
